export default __webpack_public_path__ + "static/media/filterArrowDownBlue.e86d20e2.svg";